import { useTranslation } from '@crehana/i18n';

import { DIPLOMAS_TRANSLATION_KEY } from '../constants';
import { DiplomasLocalesBundle } from '../i18n';
import type { DiplomasLocaleKeys } from '../types';

const useDiplomasTranslation = () => {
  const { addResourceBundle, ...translationContextValue } =
    useTranslation<DiplomasLocaleKeys>(DIPLOMAS_TRANSLATION_KEY);

  addResourceBundle(DiplomasLocalesBundle);

  return translationContextValue;
};

export default useDiplomasTranslation;
